<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12" sm="10" md="8" lg="6" class="content_inner">
        <div class="margin-bottom-2x">
          <span @click="back" class="curson-pointer font-size-14 text-body-2"> <v-icon left style="margin-right: 0">mdi-chevron-left</v-icon>返回 </span>
        </div>
        <v-card class="appDetail-card card-padding">
          <span v-if="info.appUserType === 'user'" class="app-type orange">用户</span>
          <span v-else-if="info.appUserType === 'mercacc'" class="app-type blue">商户</span>
          <span v-else-if="info.appUserType === 'common'" class="app-type green">通用</span>
          <h2 class="card-title">
            <div class="icon-t">
              <v-avatar class="img" size="60">
                <img :src="masterImg" :onerror="defaultAppIcon" />
              </v-avatar>
            </div>
            <div class="title-main">
              <p>{{ info.appName }}</p>
              <p class="nameEn">{{ info.appNameEn }}</p>
            </div>
          </h2>
          <v-card-text>
            <div class="d-inline-flex align-center line-item">
              <span class="line-label">图标：</span>
              <div class="line-right d-inline-flex align-center">
                <div class="icon-item" v-for="item in img" :key="item.code">
                  <p class="icon-type">{{ item.name }}</p>
                  <v-avatar class="img" size="42">
                    <img :src="item.src" :onerror="defaultAppIcon" />
                  </v-avatar>
                </div>
              </div>
            </div>
            <div class="d-inline-flex line-item">
              <span class="line-label">简介：</span>
              <div class="line-right">{{ info.appDesc || "暂无" }}</div>
            </div>
            <!-- <div class="d-inline-flex line-item">
              <span class="line-label">平台类型：</span>
              <div class="line-right">
                <span v-for="(item, i) in info.platType.split(',')" :key="i"
                  >{{ platTypeLevel.find((e) => e.code === item).name }}
                  <span v-if="i < info.platType.split(',').length - 1">，</span>
                </span>
              </div>
            </div> -->
            <div class="d-inline-flex line-item line-url">
              <span class="line-label">地址：</span>
              <div class="line-right">
                <div class="url-item" v-for="(item, i) in url" :key="i">
                  <div>
                    <span class="lable">{{ item.name }}</span>
                    <div class="value">
                      <p>url：{{ item.url }}</p>
                      <p v-if="item.routingParameters === 1">route：{{ item.route }}</p>
                      <p v-if="item.appIdRequired === 1">appId：{{ item.appId }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <v-divider></v-divider>
            <h3 class="title-h3">应用介绍：</h3>
            <div v-if="this.info.richText" class="ql-snow ql-editor" v-html="this.info.richText"></div>
            <div v-else style="padding: 150px 0; font-size: 30px; text-align: center; color: #ccc">暂无介绍~~~</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { buildAxios } from '@/plugins/axios'
import { handleResponse } from '@/plugins/errorHandler'
export default {
  components: {
  },
  data () {
    return {
      info: {},
      defaultAppIcon: 'this.src="' + require('@/assets/icon/example.svg') + '"',
      appCode: this.$route.query.appCode,
      img: [],
      masterImg: '',
      url: []
    }
  },
  computed: {
    ...mapState(['platTypeLevel'])
  },
  watch: {
  },
  created () {
    // this.info = JSON.parse(localStorage.getItem('appDetail'))
    this.getInfo()
    console.log('platTypeLevel', this.platTypeLevel)
  },
  methods: {
    back () {
      this.$router.back(-1)
    },
    // submit
    getInfo () {
      const request = buildAxios()
      request.get('baseApp/getOne?appCode=' + this.appCode).then(res => {
        this.info = res.data.data
        this.img = this.info.extraConfig.img || []
        const masterImgObj = this.img.find(item => {
          return item.src !== ''
        })
        this.masterImg = masterImgObj ? masterImgObj.src : ''
        this.info.extraConfig.url.forEach(element => {
          if (element.children && element.children.length > 0) {
            this.url = this.url.concat(element.children)
          } else {
            this.url = this.url.concat(element)
          }
        })
        console.log('输出 : created : this.info', this.url)
      }).catch(reason => {
        this.$emit('alert', {
          msg: handleResponse(reason.response),
          type: 'error'
        })
      })
    }
  }
}
</script>
<style>
.line-url .url-item {
  border-bottom: 1px dashed #eee;
  overflow: hidden;
  padding: 5px 0;
}
.line-url .url-item:last-child {
  border-bottom: 0;
}
.line-url .url-item .lable {
  margin-right: 10px;
  width: 100px;
  float: left;
  background-color: rgb(246, 246, 246);
  /* border: 1px solid #ccc; */
  text-align: center;
  border-radius: 4px;
}
.line-url .url-item .value {
  float: left;
}
.line-url .url-item p {
  margin-bottom: 0;
}
</style>
